import { useTranslation } from 'react-i18next'

import { formatRelativeTime } from '@/utils/date'

import * as S from './updated-at.styled'

interface UpdatedAtProps {
  value?: number
}

export const UpdatedAt = ({ value }: UpdatedAtProps) => {
  const { t } = useTranslation(['organisation'])

  if (!value) return null

  return (
    <S.Text color="black500" size="text-small" title={new Date(value).toLocaleString()}>
      {t('organisation:shared.updatedAgo', { time: formatRelativeTime(value) })}
    </S.Text>
  )
}
